/**
 * Formatting utilities for financial data display.
 * All number formatting happens here on the frontend — backend sends raw numbers.
 */

const sekFormatter = new Intl.NumberFormat('sv-SE', {
  style: 'currency',
  currency: 'SEK',
  maximumFractionDigits: 0,
});

const sekDecimalFormatter = new Intl.NumberFormat('sv-SE', {
  style: 'currency',
  currency: 'SEK',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const numberFormatter = new Intl.NumberFormat('sv-SE', {
  maximumFractionDigits: 0,
});

const percentFormatter = new Intl.NumberFormat('sv-SE', {
  style: 'percent',
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

export const formatSEK = (amount) => {
  if (amount == null) return '—';
  return sekFormatter.format(amount);
};

export const formatSEKDecimal = (amount) => {
  if (amount == null) return '—';
  return sekDecimalFormatter.format(amount);
};

export const formatNumber = (value) => {
  if (value == null) return '—';
  return numberFormatter.format(value);
};

export const formatPercent = (value) => {
  if (value == null) return '—';
  // value is already in percentage form (e.g., 13.6 means 13.6%)
  return percentFormatter.format(value / 100);
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  try {
    return new Date(dateStr).toLocaleDateString('sv-SE');
  } catch {
    return dateStr;
  }
};

export const formatCellValue = (value, format) => {
  if (value == null || value === '') return '—';
  switch (format) {
    case 'currency': return formatSEK(value);
    case 'percentage': return formatPercent(value);
    case 'number': return formatNumber(value);
    case 'date': return formatDate(value);
    default: return String(value);
  }
};
